import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap/dist/js/bootstrap'
import './assets/style.css'
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
      <App />
      <div className="modal" id="exactModal">
        <div className="modal-dialog modal-fullscreen-xxl-down">
            <div className="modal-content">

              <div className="modal-header">
                  <button type="button" className="btn-close" data-bs-dismiss="modal"></button>
              </div>

              <div className="modal-body">
                  <input type="text" placeholder='Rechercher dans la boutique' autoFocus />
                  <h1>PRODUITS POPULAIRES</h1>
                  <div className="produits">
                    <span>Dunk Low Panda</span>
                    <span>Air Force 1 Low Triple White</span>
                  </div>
              </div>
            </div>
        </div>
      </div>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
